import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=96ff5cbc&scoped=true&"
import script from "./TransactionList.vue?vue&type=script&lang=ts&"
export * from "./TransactionList.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionList.vue?vue&type=style&index=0&id=96ff5cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ff5cbc",
  null
  
)

export default component.exports